'use strict';
define(['../DropdownMenu'], function (DropdownMenu) {

    return {
        close: function () {
            // get existing instance of the dropdown menu object
            var dropdownMenu = DropdownMenu.get('HEADER_DROPDOWN_MENU');

            dropdownMenu.toggleDropdown.apply(dropdownMenu);
        }
    };
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/TopNavDropdown.js